export default __webpack_public_path__ + "static/media/mark-profile.346628b0.jpg";